import {FlagProps} from 'platform/components';

import {TireStatus} from '../types/TireStatus';

export const getDraftTireSetFlags = (tireSetStatus: TireStatus): FlagProps[] =>
  tireSetStatus.label && tireSetStatus.colorScheme
    ? [{label: tireSetStatus.label, colorScheme: tireSetStatus.colorScheme}]
    : [];
